import { iContactInfoDisplay, iFVSInfoDisplay, iReviewInfoDisplay, iNominationInfoDisplay } from '@interfaces/interfaces';
import { FormType } from '@constants';

const { THIRDPARTY, COURT, FAMILYVIOLENCESCHEME, EXTENSION, INFRINGEMENTEXTENSION, INSTALMENT, REVIEW, NOMINATION } = FormType;

export const tpContactInfoDisplayObject: iContactInfoDisplay = {
  mode: THIRDPARTY,
  fields: {
    title: {
      formikName: 'MrMrsMsMissOtherTwo',
    },
    givenName: {
      formikName: 'FirstOrGivenNames',
    },
    familyName: {
      formikName: 'LastNameOrFamilyName',
    },
    dateOfBirth: {
      formikName: 'DateOfBirth',
    },
    driverLicence: {
      formikName: 'DriverLicenceNumberOptional',
      title: 'Driver licence',
    },
    address: {
      formikName: 'ResidentialAddress',
      title: 'Residential address',
    },
    isAddressSameAsPostal: {
      formikName: 'IsResidentialAddressSameAsPostal',
      title: 'Is your postal address different to your residential address?',
    },
    postalAddress: {
      formikName: 'ResidentialPostalAddress',
      title: 'Postal address',
    },
    contactNumber: {
      formikName: 'UserContactNumber',
    },
    contactNumberWarning: {
      formikName: 'UserContactNumberWarning',
    },
    contactNumberSecondaryWarning: {
      formikName: ''
    },
    noEmailAddress: {
      formikName: 'NoEmailAddressThree',
    },
    emailAddress: {
      formikName: 'EmailAddressOptionalThree',
    },
    emailAddressWarning: {
      formikName: 'EmailAddressOptionalThreeWarning'
    },
    emailTo: {
      formikName: 'EMAIL_TO',
      title: 'Would you like to receive a copy of the completed application at the email address provided?',
    },
  },
};

export const courtContactInfoDisplayObject: iContactInfoDisplay = {
  mode: COURT,
  fields: {
    title: {
      formikName: 'TitleMrMrsMsMissOther',
    },
    givenName: {
      formikName: 'GivenNames',
    },
    familyName: {
      formikName: 'FamilyName',
    },
    dateOfBirth: {
      formikName: 'DOB',
    },
    driverLicence: {
      formikName: 'DRIVER_LICENCE',
      title: 'Driver licence',
    },
    address: {
      formikName: 'SummonsAddress',
      title: 'Address for service of summons',
    },
    isAddressSameAsPostal: {
      formikName: 'HasDifferentResidentialAddress',
      title: 'Is your residential address different to your postal address?',
    },
    postalAddress: {
      formikName: 'ResidentialAddress',
      title: 'Residential address',
    },
    contactNumber: {
      formikName: 'CourtContactNumber',
    },
    contactNumberWarning: {
      formikName: 'CourtContactNumberWarning',
    },
    contactNumberSecondaryWarning: {
      formikName: 'CourtContactNumberWarningSec'
    },
    noEmailAddress: {
      formikName: 'NoEmail',
    },
    emailAddress: {
      formikName: 'Email',
    },
    emailAddressWarning: {
      formikName: 'EmailWarning'
    },
    emailTo: {
      formikName: 'EMAIL_TO',
      title: 'Would you like to receive a copy of the completed application at the email address provided?',
    },
  },
};
export const extensionContactInfoDisplayObject: iContactInfoDisplay = {
  mode: EXTENSION,
  fields: {
    title: {
      formikName: 'TitleMrMrsMsMissOther',
    },
    givenName: {
      formikName: 'GivenNames',
    },
    familyName: {
      formikName: 'FamilyName',
    },
    dateOfBirth: {
      formikName: 'DOB',
    },
    driverLicence: {
      formikName: 'DRIVER_LICENCE',
      title: 'Driver licence',
    },
    address: {
      formikName: 'ExtensionPostalAddress',
      title: 'Postal address',
    },
    isAddressSameAsPostal: {
      formikName: 'HasDifferentResidentialAddress',
      title: 'Is your residential address different to your postal address?',
    },
    postalAddress: {
      formikName: 'ExtensionResidentialAddress',
      title: 'Residential address',
    },
    contactNumber: {
      formikName: 'ExtensionContactNumber',
    },
    contactNumberWarning: {
      formikName: 'ExtensionContactNumberWarning',
    },
    contactNumberSecondaryWarning: {
      formikName: 'ExtensionContactNumberWarningSecond'
    },
    noEmailAddress: {
      formikName: 'NoEmail',
    },
    emailAddress: {
      formikName: 'Email',
    },
    emailAddressWarning: {
      formikName: 'EmailWarning',
    },
    emailTo: {
      formikName: 'EMAIL_TO',
      title: 'Would you like to receive a copy of the completed application at the email address provided?',
    },
    receiveDocs: {
      formikName: 'receiveDocs',
      title: 'I consent to receive documentation electronically',
    }
  },
};

export const fvsInfoDisplayObject: iFVSInfoDisplay = {
  mode: FAMILYVIOLENCESCHEME,
  pages: {
    /* Page Type: Risk and support details - Step 7 and Step 16 */
    riskAndSupportDetails: {
      step7: {
        pageTitle: 'Your risk and support details',
        fields: {
          hasScaredFeelings: {
            formikName: 'HasScaredFeelings',
            title: 'Are you or your children currently feeling afraid of a family member or experiencing family violence?',
          },
          hasRiskAssessment: {
            formikName: 'HasRiskAssessment',
            title: 'Has a support agency completed a risk assessment and safety plan with you?',
          },
          contactSpecialist: {
            formikName: 'ContactSpecialist',
            title:
              'Would you like Fines Victoria to contact you to provide information about specialist family violence support services such as Safe Steps, 1800 Respect and Orange Door?',
          },
          additionalText: {
            formikName: 'additionalText',
            title:
              'Please ensure you have given us permission to phone you, and information about the safest times to call you.',
          },
        },
      },
      step16: {
        pageTitle: "Fineholder's risk and support details",
        fields: {
          hasScaredFeelings: {
            formikName: 'HasScaredFeelings',
            title: 'Is the fineholder (or their children) currently feeling afraid of a family member or experiencing family violence?',
          },
          hasRiskAssessment: {
            formikName: 'HasRiskAssessment',
            title: 'Has a support agency done a risk assessment and safety plan with the fineholder?',
          },
          contactSpecialist: {
            formikName: 'ContactSpecialist',
            title:
              'Would you like Fines Victoria to contact you to provide information about specialist family violence support services such as Safe Steps, 1800 Respect and Orange Door?',
          },
          additionalText: {
            formikName: 'additionalText',
            title:
              'Please ensure you have given us permission to phone you, and information about the best times to call you.',
          },
        },
      },
    },
    /* Page Type: Background and identity details - Step 8 and Step 17 */
    backgroundAndIdentityDetails: {
      step8: {
        pageTitle: 'Your background and identity (optional)',
        pageSubtitle: 'Responses will assist with our risk assessment process, but will not impact the success of your application.',
        pageInfo: 'The answers may also assist with de-identified statistical reporting.',
        fields: {
          gender: {
            formikName: 'Gender',
            title: 'What is your gender?',
          },
          genderDescription: {
            formikName: 'GenderSelfDescribed',
            title: 'Please specify',
          },
          lgtiqIdentified: {
            formikName: 'LGBTIQIdentified',
            title: 'Do you identify as LGBTIQ?',
          },
          origin: {
            formikName: 'Origin',
            title: 'Do you identify as Aboriginal and/or Torres Strait Islander?',
          },
          englishProficiency: {
            formikName: 'EnglishProficiency',
            title: 'How well can you communicate in English?',
          },
          nativeLanguage: {
            formikName: 'NativeLanguage',
            title: 'What is the main language spoken at home?',
          },
          isDisabled: {
            formikName: 'HasDisability',
            title: 'Do you have a disability or an impairment?',
          },
          disabilityDescription: {
            formikName: 'DisabilityDescription',
            title: 'Please specify',
          },
        },
      },
      step17: {
        pageTitle: "Fineholder's background and identity (optional)",
        pageSubtitle: "Your responses help with our risk assessment process, and will not impact the success of the fineholder's application.",
        pageInfo: 'The answers will assist with de-identified statistical reporting and potential risk identification.',
        fields: {
          gender: {
            formikName: 'Gender',
            title: 'What is their gender?',
          },
          genderDescription: {
            formikName: 'GenderSelfDescribed',
            title: 'Please specify',
          },
          lgtiqIdentified: {
            formikName: 'LGBTIQIdentified',
            title: 'Do they identify as LGBTIQ?',
          },
          origin: {
            formikName: 'Origin',
            title: 'Do they identify as Aboriginal and/or Torres Strait Islander?',
          },
          englishProficiency: {
            formikName: 'EnglishProficiency',
            title: 'How well can they communicate in English?',
          },
          nativeLanguage: {
            formikName: 'NativeLanguage',
            title: 'What is the main language spoken at home?',
          },
          isDisabled: {
            formikName: 'HasDisability',
            title: 'Do they have a disability or an impairment?',
          },
          disabilityDescription: {
            formikName: 'DisabilityDescription',
            title: 'Please provide details',
          },
        },
      },
    },
    /* Page Type: Likely possibilities - Step 10 and Step 19 */
    likelyPossibilities: {
      step10: {
        pageTitle: 'What would you like to happen?',
        fields: {
          likelyPossibility: {
            formikName: 'WhatWouldYouLikeToHappen',
            title: '',
          },
          givenNameOptional: {
            formikName: 'GivenNamesOptional',
            title: 'Given name(s)',
          },
          familyNameOptional: {
            formikName: 'FamilyNameOptional',
            title: 'Family name',
          },
          dateOfBirthOptional: {
            formikName: 'DOBOptional',
            title: 'Date of birth',
          },
          driverLicenceOptional: {
            formikName: 'DriverLicenceNumberOptional',
            title: 'Driver licence number',
          },
          licenceStateOptional: {
            formikName: 'LicenceStateOptional',
            title: '',
          },
          stateCountryOfIssueOptional: {
            formikName: 'StatecountryOfIssueOptional',
            title: '',
          },
          noDriverLicenceOptional: {
            formikName: 'NoDriverLicenceOptional',
            title: '',
          },
          howDealtWithFines: {
            formikName: 'HowDealtWithFines',
            title: 'Please provide further details of how you would like each fine to be dealt with',
          },
        },
      },
      step19: {
        pageTitle: 'What would you like to happen?',
        fields: {
          likelyPossibility: {
            formikName: 'WhatWouldYouLikeToHappen',
            title: '',
          },
          givenNameOptional: {
            formikName: 'GivenNamesOptional',
            title: 'Given name(s)',
          },
          familyNameOptional: {
            formikName: 'FamilyNameOptional',
            title: 'Family name',
          },
          dateOfBirthOptional: {
            formikName: 'DOBOptional',
            title: 'Date of birth',
          },
          driverLicenceOptional: {
            formikName: 'DriverLicenceNumberOptional',
            title: 'Driver licence number',
          },
          licenceStateOptional: {
            formikName: 'LicenceStateOptional',
            title: '',
          },
          stateCountryOfIssueOptional: {
            formikName: 'StatecountryOfIssueOptional',
            title: '',
          },
          noDriverLicenceOptional: {
            formikName: 'NoDriverLicenceOptional',
            title: '',
          },
          howDealtWithFines: {
            formikName: 'HowDealtWithFines',
            title: 'Please provide further details of how you would like each fine to be dealt with',
          },
        },
      },
    },
    /* Page Type: Payment arrangements - Step 11 and Step 20 */
    paymentArrangements: {
      step11: {
        pageTitle: 'Payment arrangements',
        pageSubtitle: 'Please note that if you pay the fines in full, they will no longer be eligible for the scheme.',
        fields: {
          removeFines: {
            formikName: 'RemoveFines',
            title: 'Would you like us to remove the relevant fines from your payment arrangement while we consider your application?',
          },
          reincludeFines: {
            formikName: 'ReincludeFines',
            title: 'If your application is not successful, would you like us to propose a new payment arrangement to include these fines again?',
          },
        },
      },
      step20: {
        pageTitle: 'Payment arrangements',
        pageSubtitle: 'Please note that if the fineholder pays the fines in full they will no longer be eligible for the scheme.',
        fields: {
          hasPaymentArrangement: {
            formikName: 'HasPaymentArrangement',
            title: 'Does the fineholder have a payment arrangement with Fines Victoria for any of the fines in this application?',
          },
          removeFines: {
            formikName: 'RemoveFines',
            title: 'Would the fineholder like us to remove the relevant fines from the payment arrangement while we consider the application?',
          },
          reincludeFines: {
            formikName: 'ReincludeFines',
            title: 'If the application is not successful, would the fineholder like us to propose a new payment arrangement to include these fines again?',
          },
        },
      },
    },
    /* Page Type: Victim Information - Step 6 and Step 15 */
    contactInformation: {
      step15: {
        pageTitle: "Fineholder's details",
        pageSubtitle: 'We will not share any information with the perpetrator of the family violence.',
        fields: {
          givenName: {
            formikName: 'GivenNames',
            title: 'Given name(s)',
          },
          familyName: {
            formikName: 'FamilyName',
            title: 'Family name(s)',
          },
          dateOfBirth: {
            formikName: 'DOB',
            title: 'Date of birth',
          },
          driverLicence: {
            formikName: 'DRIVER_LICENCE',
            title: 'Driver licence number',
          },
          residentialAddress: {
            formikName: 'FVSResidentialAddress',
            title: "Fineholder's residential address",
          },
          noFixedAddress: {
            formikName: 'NoFixedAddress',
            title: "Select if they don't have a fixed address",
          },
          noResidentialAddress: {
            formikName: 'NoResidentialAddress',
            title: 'Select if you / they would prefer not to provide their residential address',
          },
          deliveryAddressType: {
            formikName: 'DeliveryAddressType',
            title: 'We need to send some information by post regarding the application. Please indicate the safest and preferred address for receiving correspondence.',
          },
          postalAddress: {
            formikName: 'FVSPostalAddress',
            title: 'Postal address',
          },
          noPostalAddress: {
            formikName: 'NoSafePostalAddress',
            title: "Select if you don't have a safe postal address",
          },
          isEmailRequired: {
            formikName: 'IsEmailRequired',
            title: 'Is it safe to email them about their application?',
          },
          noEmail: {
            formikName: 'NoEmail',
            title: 'Select if they do not have an email address',
          },
          email: {
            formikName: 'Email',
            title: 'Email',
          },
          sendEmailCopy: {
            formikName: 'SendEmailCopy',
            title: 'Would you like to receive a copy of the completed application at the email address provided?',
          },
          phoneApplicant: {
            formikName: 'PhoneApplicant',
            title: 'Is it safe to phone them to discuss their application? \n\r It might help determine their application quickly if we can speak with them over the phone about it.',
          },
          individualContactNumber: {
            formikName: 'IndividualContactNumber',
            title: 'Contact number',
          },
          safestContactTime: {
            formikName: 'SafestContactTime',
            title: 'What are the safest days and times to phone?',
          },
          phoneMessagePrompt: {
            formikName: 'PhoneMessagePrompt',
            title: 'Can we leave a phone message on this number?',
          },
          interpreterRequiredPrompt: {
            formikName: 'InterpreterRequiredPrompt',
            title: 'Do they need an interpreter to assist you if we phone them?',
          },
          alternativeLanguage: {
            formikName: 'AlternativeLanguage',
            title: 'Which language?',
          },
        },
      },
      step6: {
        pageTitle: 'Your details',
        pageSubtitle: 'We will not share any information with the perpetrator of the family violence.',
        fields: {
          givenName: {
            formikName: 'GivenNames',
            title: 'Given name(s)',
          },
          familyName: {
            formikName: 'FamilyName',
            title: 'Family name',
          },
          dateOfBirth: {
            formikName: 'DOB',
            title: 'Date of birth',
          },
          driverLicence: {
            formikName: 'DRIVER_LICENCE',
            title: 'Driver licence number',
          },
          residentialAddress: {
            formikName: 'FVSResidentialAddress',
            title: 'Residential address',
          },
          noFixedAddress: {
            formikName: 'NoFixedAddress',
            title: "Select if you don't have a fixed address",
          },
          noResidentialAddress: {
            formikName: 'NoResidentialAddress',
            title: 'Select if you would prefer not to provide your residential address',
          },
          deliveryAddressType: {
            formikName: 'DeliveryAddressType',
            title: 'We need to send some information by post regarding the application. Please indicate the safest and preferred address for receiving correspondence.',
          },
          postalAddress: {
            formikName: 'FVSPostalAddress',
            title: 'Postal address - Safest address for receiving correspondence.\nThis could be a PO Box or address of a friend, relative.',
          },
          noPostalAddress: {
            formikName: 'NoSafePostalAddress',
            title: "Select if you don't have a safe postal address",
          },
          isEmailRequired: {
            formikName: 'IsEmailRequired',
            title: 'Is it safe to email you about your application?',
          },
          noEmail: {
            formikName: 'NoEmail',
            title: 'Select if you do not have an email address',
          },
          email: {
            formikName: 'Email',
            title: 'Email',
          },
          sendEmailCopy: {
            formikName: 'SendEmailCopy',
            title: 'Would you like to receive a copy of the completed application at the email address provided?',
          },
          phoneApplicant: {
            formikName: 'PhoneApplicant',
            title: 'Is it safe to phone you to discuss your application? \n\r It might help determine your application quickly if we can speak with you over the phone about it.',
          },
          individualContactNumber: {
            formikName: 'IndividualContactNumber',
            title: 'Contact number',
          },
          safestContactTime: {
            formikName: 'SafestContactTime',
            title: 'What are the safest days and times to phone?',
          },
          phoneMessagePrompt: {
            formikName: 'PhoneMessagePrompt',
            title: 'Can we leave a phone message on this number?',
          },
          interpreterRequiredPrompt: {
            formikName: 'InterpreterRequiredPrompt',
            title: 'Do you need an interpreter to assist you if we phone you?',
          },
          alternativeLanguage: {
            formikName: 'AlternativeLanguage',
            title: 'Which language?',
          },
        },
      },
    },
    /* Page type: Reason for application - Step 12 and 21 */
    supportingDocuments: {
      step12: {
        pageTitle: 'Supporting documents',
        fields: {
          isUnableToObtainADoc: {
            formikName: 'UnableToObtainAdoc',
            title: 'I do not have a document prepared by a relevant authority or professional',
          },
        },
      },
      step21: {
        pageTitle: 'Supporting documents',
        fields: {
          isUnableToObtainADoc: {
            formikName: 'UnableToObtainAdoc',
            title: 'I do not have a document prepared by a relevant authority or professional',
          },
        },
      },
    },
    /* Page type: Reason for application - Step 13 and 22 */
    applicationReasons: {
      step13: {
        pageTitle: 'Reasons for application',
        // pageSubtitle: 'Use this section to describe why you think you’re eligible for the family violence scheme.',
        fields: {
          reason: {
            formikName: 'ReasonForApplication',
            title: 'Please describe your reason',
          },
        },
      },
      step22: {
        pageTitle: 'Reasons for application',
        // pageSubtitle: 'Use this section to describe why you think you’re eligible for the family violence scheme.',
        fields: {
          reason: {
            formikName: 'ReasonForApplication',
            title: 'Please describe your reason',
          },
        },
      },
    },
  },
};

export const infringementExtensionContactInfoDisplayObject: iContactInfoDisplay = {
  mode: INFRINGEMENTEXTENSION,
  fields: {
    givenName: {
      formikName: 'IndividualGivenName',
      title: 'Given name(s)'
    },
    familyName: {
      formikName: 'IndividualFamilyName',
      title: 'Family name (Surname)'
    },
    isFirstNations: {
      formikName: 'isFirstNations',
      title: 'Do you identify as Aboriginal and/or Torres Strait Islander?'
    },
    dateOfBirth: {
      formikName: 'DOB',
      title: 'Date of birth'
    },
    driverLicence: {
      formikName: 'DRIVER_LICENCE',
      title: 'Driver licence number',
    },
    address: {
      formikName: 'IndividualResidentialAddress',
      title: 'Residential address',
    },
    isAddressSameAsPostal: {
      formikName: 'IndividualHasDifferentPostalAddress',
      title: 'Is your postal address different to your residential address?',
    },
    postalAddress: {
      formikName: 'IndividualPostalAddress',
      title: 'Postal address',
    },
    contactNumber: {
      formikName: 'IndividualContactNumber',
    },
    contactNumberWarning: {
      formikName: 'IndividualContactNumberWarning',
    },
    noEmailAddress: {
      formikName: 'IndividualHasNoEmail',
    },
    emailAddress: {
      formikName: 'IndividualEmail',
    },
    emailAddressWarning: {
      formikName: 'IndividualEmailWarning'
    },
    emailTo: {
      formikName: 'IndividualEmailTo',
      title: 'Would you like to receive a copy of the completed application at the email address provided?',
    },
    receiveDocs: {
      formikName: 'IndividualReceiveDocs',
      title: 'Do you consent to receiving correspondence about this application electronically?',
    }
  },
};

// Infringement Extension -- Company Details Fields
export const infringementExtensionCompanyInfoDisplayObject: iContactInfoDisplay = {
  mode: INFRINGEMENTEXTENSION,
  fields: {
    givenName: {
      formikName: 'CompanyGivenName',
      title: 'Given name(s)'
    },
    familyName: {
      formikName: 'CompanyFamilyName',
      title: 'Family name (Surname)'
    },
    companyPosition: {
      formikName: 'PositionInCompany',
      title: 'Position in company'
    },
    contactNumber: {
      formikName: 'CompanyContactNumber',
    },
    noEmailAddress: {
      formikName: 'CompanyHasNoEmail',
    },
    emailAddress: {
      formikName: 'CompanyEmail',
    },
    emailTo: {
      formikName: 'CompanyEmailTo',
      title: 'Would you like to receive a copy of the completed application at the email address provided?',
    },
    receiveDocs: {
      formikName: 'CompanyReceiveDocs',
      title: 'Do you consent to receiving correspondence about this application electronically?',
    },
    companyName: {
      formikName: 'CompanyName',
      title: 'Company name',
    },
    ABNACNType: {
      formikName: 'AbnOrAcnType',
      title: 'Please enter your ABN or ACN below',
    },
    ABNNo: {
      formikName: 'AbnNo',
      title: 'ABN',
    },
    ACNNo: {
      formikName: 'AcnNo',
      title: 'ACN',
    },
    companyAddress: {
      formikName: 'CompanyStreetAddress',
      title: "Company's street address",
    },
    isAddressSameAsPostal: {
      formikName: 'CompanyHasDifferentPostalAddress',
      title: "Is the postal address different to your company's street address?",
    },
    postalAddress: {
      formikName: 'CompanyPostalAddress',
      title: 'Postal address',
    },
  },
};

export const NominationInfoDisplayObject: iNominationInfoDisplay = {
  mode: NOMINATION,
  pages: {
    /* Page Type: Victim Information - Step 6 and Step 15 */
    personalContactInformation: {
      step6: {
        pageTitle: '',
        pageSubtitle: '',
        fields: {
          givenName: {
            formikName: 'GivenNamesSomeoneElse',
            title: 'Given name(s)',
          },
          familyName: {
            formikName: 'FamilyNameSomeoneElse',
            title: 'Family name',
          },
          dateOfBirth: {
            formikName: 'DOBSomeoneElse',
            title: 'Date of birth',
          },
          dateOfBirthYesNo: {
            formikName: 'DOBYesNoSomeoneElse',
            title: 'Select if you do not know their date of birth',
          },
          driverLicence: {
            formikName: 'DriverLicenseSomeoneElse',
            title: 'Licence number',
          },
          licenceState: {
            formikName: 'LicenceStateSomeoneElse',
            title: '',
          },
          statecountryOfIssue: {
            formikName: 'StatecountryOfIssueSomeoneElse',
            title: '',
          },
          noDriverLicence: {
            formikName: 'NoDriverLicenseSomeoneElse',
            title: "Select if you don't know their licence details",
          },
          taxiDriverAccNumber: {
            formikName: 'TaxDriverAccNumber',
            title: 'Taxi driver accreditation number - required where vehicle is a taxi',
          },
          residentialAddress: {
            formikName: 'ResidentialAddressSomeoneElse',
            title: 'Residential address',
          },
          noResidentialAddress: {
            formikName: 'NoResidentialAddressSomeoneElse',
            title: 'Select if you / they would prefer not to provide their residential address',
          },
          noEmail: {
            formikName: 'NoEmailSomeoneElse',
            title: 'Select if you do not know their email address',
          },
          email: {
            formikName: 'EmailSomeoneElse',
            title: 'Email address',
          },
          individualContactNumber: {
            formikName: 'IndividualContactNumberSomeoneElse',
            title: 'Contact number',
          },
          emailWarning: {
            formikName: 'EmailSomeoneElseWarning',
            title: '',
          },
          individualContactNumberWarning: {
            formikName: 'IndividualContactNumberSomeoneElseWarning',
            title: '',
          },
          noContactNumber: {
            formikName: 'NoContactNumberSomeoneElse',
            title: 'Select if you do not know their phone number',
          },
        },
      },
      step7: {
        pageTitle: '',
        pageSubtitle: '',
        fields: {
          givenName: {
            formikName: 'GivenNamesSoldDisposed',
            title: 'Given name(s)',
          },
          familyName: {
            formikName: 'FamilyNameSoldDisposed',
            title: 'Family name',
          },
          dateOfBirth: {
            formikName: 'DOBSoldDisposed',
            title: 'Date of birth',
          },
          dateOfBirthYesNo: {
            formikName: 'DOBYesNoSoldDisposed',
            title: 'Select if you do not know their date of birth',
          },
          driverLicence: {
            formikName: 'DriverLicenseSoldDisposed',
            title: 'Licence number',
          },
          licenceState: {
            formikName: 'LicenceStateSoldDisposed',
            title: '',
          },
          statecountryOfIssue: {
            formikName: 'StatecountryOfIssueSoldDisposed',
            title: '',
          },
          noDriverLicence: {
            formikName: 'NoDriverLicenseSoldDisposed',
            title: 'Select if you do not know their licence details',
          },
          residentialAddress: {
            formikName: 'ResidentialAddressSoldDisposed',
            title: 'Residential address',
          },
          noResidentialAddress: {
            formikName: 'NoResidentialAddressSoldDisposed',
            title: 'Select if you / they would prefer not to provide their residential address',
          },
          noEmail: {
            formikName: 'NoEmailSoldDisposed',
            title: 'Select if you do not know their email address',
          },
          email: {
            formikName: 'EmailSoldDisposed',
            title: 'Email address',
          },
          individualContactNumber: {
            formikName: 'IndividualContactNumberSoldDisposed',
            title: 'Contact number',
          },
          noContactNumber: {
            formikName: 'NoContactNumberSoldDisposed',
            title: 'Select if you do not know their contact phone number',
          },
          emailWarning: {
            formikName: 'EmailSoldDisposedWarning',
            title: '',
          },
          individualContactNumberWarning: {
            formikName: 'IndividualContactNumberSoldDisposedWarning',
            title: '',
          },
        },
      },
      step11: {
        pageTitle: '',
        pageSubtitle: '',
        fields: {
          givenName: {
            formikName: 'GivenNamesYourDetails',
            title: 'Given name(s)',
          },
          familyName: {
            formikName: 'FamilyNameYourDetails',
            title: 'Family name',
          },
          dateOfBirth: {
            formikName: 'DOBYourDetails',
            title: 'Date of birth',
          },
          driverLicence: {
            formikName: 'DRIVER_LICENCE',
            title: 'Licence number',
          },
          licenceState: {
            formikName: 'LicenceStateYourDetails',
            title: '',
          },
          statecountryOfIssue: {
            formikName: 'StatecountryOfIssueYourDetails',
            title: '',
          },
          noDriverLicence: {
            formikName: 'NoDriverLicenseYourDetails',
            title: 'Select if you do not hold a current driver licence',
          },
          postalAddress: {
            formikName: 'IndividualPostalAddressYourDetails',
            title: 'Postal address',
          },
          differentToPostal: {
            formikName: 'DifferentToPostalYourDetails',
            title: 'Is your residential address different to your postal address?',
          },
          residentialAddress: {
            formikName: 'ResidentialAddressYourDetails',
            title: 'Residential address',
          },
          noEmail: {
            formikName: 'NoEmailYourDetails',
            title: 'Select if you do not have an email address',
          },
          email: {
            formikName: 'EmailYourDetails',
            title: 'Email address',
          },
          individualContactNumber: {
            formikName: 'IndividualContactNumberYourDetails',
            title: 'Contact number',
          },
          noContactNumber: {
            formikName: 'NoContactNumberYourDetails',
            title: 'Select if you do not have a contact phone number',
          },
          emailWarning: {
            formikName: 'EmailYourDetailsWarning',
            title: '',
          },
          individualContactNumberWarning: {
            formikName: 'IndividualContactNumberYourDetailsWarning',
            title: '',
          },
        },
      },
    },
    companyContactInformation: {
      step6: {
        pageTitle: '',
        pageSubtitle: '',
        fields: {
          companyName: {
            formikName: 'CompanyNameSomeoneElse',
            title: 'Company name',
          },
          abnacnType: {
            formikName: 'AbnacnTypeSomeoneElse',
            title: 'ACN or ABN (an ACN is preferred)',
          },
          acnNo: {
            formikName: 'AcnNoSomeoneElse',
            title: 'Enter the ACN number',
          },
          isACNValid: {
            formikName: 'isACNValidSomeoneElse',
            title: '',
          },
          abnNo: {
            formikName: 'AbnNoSomeoneElse',
            title: 'Enter the ABN number',
          },
          isABNValid: {
            formikName: 'isABNValidSomeoneElse',
            title: '',
          },
          companyStreetAddress: {
            formikName: 'CompanyStreetAddressSomeoneElse',
            title: 'Street address',
          },
          organisationContactNumber: {
            formikName: 'OrganisationContactNumberSomeoneElse',
            title: 'Contact phone number',
          },
          noContactNumber: {
            formikName: 'NoOrgContactNumberSomeoneElse',
            title: 'Select if you do not know the phone number',
          },
          emailAddress: {
            formikName: 'CompanyEmailSomeOneElse',
            title: 'Email address',
          },
          emailAddressWarning: {
            formikName: 'CompanyEmailSomeOneElseWarning',
            title: '',
          },
          organisationContactNumberWarning: {
            formikName: 'OrganisationContactNumberSomeoneElseWarning',
            title: '',
          },
          emailAddressYesNo: {
            formikName: 'CompanyEmailYesNoSomeOneElse',
            title: 'Select if you do not know the email address',
          },
        },
      },
      step7: {
        pageTitle: '',
        pageSubtitle: '',
        fields: {
          companyName: {
            formikName: 'CompanyNameSoldDisposed',
            title: 'Company name',
          },
          abnacnType: {
            formikName: 'AbnacnTypeSoldDisposed',
            title: 'ACN or ABN (an ACN is preferred)',
          },
          acnNo: {
            formikName: 'AcnNoSoldDisposed',
            title: 'Enter the ACN number',
          },
          isACNValid: {
            formikName: 'isACNValidSoldDisposed',
            title: '',
          },
          organisationContactNumberYesNo: {
            formikName: 'OrganisationContactNumberYesNoSoldDisposed',
            title: 'Select if you do not know the phone number',
          },
          abnNo: {
            formikName: 'AbnNoSoldDisposed',
            title: 'Enter the ABN number',
          },
          isABNValid: {
            formikName: 'isABNValidSoldDisposed',
            title: '',
          },
          companyStreetAddress: {
            formikName: 'CompanyStreetAddressSoldDisposed',
            title: 'Street address',
          },
          organisationContactNumber: {
            formikName: 'OrganisationContactNumberSoldDisposed',
            title: 'Contact phone number',
          },
          noContactNumber: {
            formikName: 'NoOrgContactNumberSoldDisposed',
            title: 'Select if you do not know the phone number',
          },
          emailAddress: {
            formikName: 'CompanyEmailSoldDisposed',
            title: 'Email address',
          },
          emailAddressYesNo: {
            formikName: 'CompanyEmailYesNoSoldDisposed',
            title: 'Select if you do not know the email address',
          },
          emailAddressWarning: {
            formikName: 'CompanyEmailSoldDisposedWarning',
            title: '',
          },
          organisationContactNumberWarning: {
            formikName: 'OrganisationContactNumberSoldDisposedWarning',
            title: '',
          },
        },
      },
      step11: {
        pageTitle: '',
        pageSubtitle: '',
        fields: {
          givenName: {
            formikName: 'GivenNamesYourDetailsCompany',
            title: 'Given name(s)',
          },
          familyName: {
            formikName: 'FamilyNameYourDetailsCompany',
            title: 'Family name',
          },
          positionInCompany: {
            formikName: 'PositionInCompanyYourDetailsCompany',
            title: 'Position in company',
          },
          organisationContactNumber: {
            formikName: 'OrganisationContactNumberYourDetailsCompany',
            title: 'Contact phone number',
          },
          noContactNumber: {
            formikName: 'NoOrgContactNumberYourDetails',
            title: 'Select if you do not know the phone number',
          },
          emailAddress: {
            formikName: 'CompanyEmailYourDetails',
            title: 'Email address',
          },
          emailAddressYesNo: {
            formikName: 'CompanyEmailYesNoYourDetails',
            title: 'Select if you do not have an email address',
          },
          companyName: {
            formikName: 'CompanyNameYourDetailsCompany',
            title: 'Company name',
          },
          abnacnType: {
            formikName: 'AbnacnTypeYourDetails',
            title: 'ACN or ABN (an ACN is preferred)',
          },
          acnNo: {
            formikName: 'AcnNoYourDetails',
            title: 'Enter the ACN number',
          },
          isACNValid: {
            formikName: 'isACNValidYourDetails',
            title: '',
          },
          organisationContactNumberYesNo: {
            formikName: 'OrganisationContactNumberYesNoYourDetails',
            title: 'Select if you do not know the phone number',
          },
          abnNo: {
            formikName: 'AbnNoYourDetails',
            title: 'Enter the ABN number',
          },
          isABNValid: {
            formikName: 'isABNValidYourDetails',
            title: '',
          },
          companyStreetAddress: {
            formikName: 'CompanyStreetAddressYourDetails',
            title: "Company's street address",
          },
          differentToStreetAddress: {
            formikName: 'DifferentToStreetAddressYourDetails',
            title: 'Is the postal address different to the street address?',
          },
          companyPostalAddress: {
            formikName: 'CompanyPostalAddressYourDetails',
            title: "Company's postal address",
          },
          emailAddressWarning: {
            formikName: 'CompanyEmailYourDetailsWarning',
            title: '',
          },
          organisationContactNumberWarning: {
            formikName: 'OrganisationContactNumberYourDetailsCompanyWarning',
            title: '',
          },
        },
      },
    }
  },
};

export const instalmentContactInfoDisplayObject: iContactInfoDisplay = {
  mode: INSTALMENT,
  fields: {
    givenName: {
      formikName: 'IndividualGivenName',
      title: 'Given name(s)'
    },
    familyName: {
      formikName: 'IndividualFamilyName',
      title: 'Family name'
    },
    isFirstNations: {
      formikName: 'isFirstNations',
      title: 'Do you identify as Aboriginal and/or Torres Strait Islander?'
    },
    dateOfBirth: {
      formikName: 'DOB',
      title: 'Date of birth'
    },
    driverLicence: {
      formikName: 'DRIVER_LICENCE',
      title: 'Driver licence number',
    },
    address: {
      formikName: 'IndividualPostalAddress',
      title: 'Postal address',
    },
    isAddressSameAsPostal: {
      formikName: 'IndividualHasDifferentResidentialAddress',
      title: 'Is your residential address different to your postal address?',
    },
    postalAddress: {
      formikName: 'IndividualResidentialAddress',
      title: 'Residential address',
    },
    contactNumber: {
      formikName: 'IndividualContactNumber',
    },
    contactNumberWarning: {
      formikName: 'IndividualContactNumberWarning',
    },
    noEmailAddress: {
      formikName: 'IndividualHasNoEmail',
    },
    emailAddress: {
      formikName: 'IndividualEmail',
    },
    emailTo: {
      formikName: 'IndividualEmailTo',
      title: 'Would you like to receive a copy of the completed application at the email address provided?',
    },
    emailAddressWarning: {
      formikName: 'IndividualEmailWarning'
    },
    receiveDocs: {
      formikName: 'IndividualReceiveDocs',
      title: 'Do you consent to receiving correspondence about this application via email?',
    }
  },
};

// Instalment -- Company Details Fields
export const instalmentCompanyInfoDisplayObject: iContactInfoDisplay = {
  mode: INSTALMENT,
  fields: {
    givenName: {
      formikName: 'CompanyGivenName',
      title: 'Given name(s)'
    },
    familyName: {
      formikName: 'CompanyFamilyName',
      title: 'Family name'
    },
    companyPosition: {
      formikName: 'PositionInCompany',
      title: 'Position in company'
    },
    contactNumber: {
      formikName: 'CompanyContactNumber',
    },
    contactNumberWarning: {
      formikName: 'CompanyContactNumberWarning',
    },
    noEmailAddress: {
      formikName: 'CompanyHasNoEmail',
    },
    emailAddress: {
      formikName: 'CompanyEmail',
    },
    emailAddressWarning: {
      formikName: 'CompanyEmailWarning'
    },
    emailTo: {
      formikName: 'CompanyEmailTo',
      title: 'Would you like to receive a copy of the completed application at the email address provided?',
    },
    receiveDocs: {
      formikName: 'CompanyReceiveDocs',
      title: 'Do you consent to receiving correspondence about this application via email?',
    },
    companyName: {
      formikName: 'CompanyName',
      title: 'Company name',
    },
    ABNACNType: {
      formikName: 'AbnOrAcnType',
      title: 'Please enter your ACN or ABN below',
    },
    ABNNo: {
      formikName: 'AbnNo',
      title: 'ABN',
    },
    ACNNo: {
      formikName: 'AcnNo',
      title: 'ACN',
    },
    companyAddress: {
      formikName: 'CompanyStreetAddress',
      title: "Company's street address",
    },
    isAddressSameAsPostal: {
      formikName: 'CompanyHasDifferentPostalAddress',
      title: "Is the postal address different to your company's street address?",
    },
    postalAddress: {
      formikName: 'CompanyPostalAddress',
      title: 'Postal address',
    },
  },
};

export const reviewInfoDisplayObject: iReviewInfoDisplay = { // TODO - remove this if not required
  mode: REVIEW,
  pages: {
    IndividualContactInformation: {
      pageTitle: 'Your details',
      pageSubtitle: 'All fields are required unless specified otherwise',
      fields: {
        givenName: {
          formikName: 'GivenNamesYourDetailsIndividual',
          title: 'Given name(s)',
        },
        familyName: {
          formikName: 'FamilyNameYourDetailsIndividual',
          title: 'Family name',
        },
        dateOfBirth: {
          formikName: 'DOBYourDetailsIndividual',
          title: 'Date of birth',
        },
        driverLicence: {
          formikName: 'DRIVER_LICENCE',
          title: 'Driver licence number',
        },
        licenceState: {
          formikName: 'StateOfIssueYourDetailsIndividual',
          title: '',
        },
        countryOfIssue: {
          formikName: 'PlaceOfIssueYourDetailsIndividual',
          title: '',
        },
        noDriverLicence: {
          formikName: 'YesNoDriverLicenceYourDetailsIndividual',
          title: 'Select if you do not have a current driver licence',
        },
        postalAddress: {
          formikName: 'PostalAddressYourDetailsIndividual',
          title: 'Postal address',
        },
        isAddressSameAsPostal: {
          formikName: 'DifferentToPostalYourDetailsIndividual',
          title: 'Is your residential address different to your postal address?',
        },
        residentialAddress: {
          formikName: 'ResidentialAddressYourDetailsIndividual',
          title: 'Residential address',
        },
        contactNumber: {
          formikName: 'ContactNumberYourDetailsIndividual',
          title: '',
        },
        emailAddress: {
          formikName: 'EmailYourDetailsIndividual',
          title: '',
        },
        noEmail: {
          formikName: 'YesNoEmailYourDetailsIndividual',
          title: 'Select if you do not have an email address',
        },
        receiveApplication: {
          formikName: 'ReceiveApplicationViaEmailYourDetailsIndividual',
          title: 'Would you like to receive a copy of the completed application at the email address provided?',
        },
        receiveCorrespondence: {
          formikName: 'ReceiveCorrespondenceViaEmailYourDetailsIndividual',
          title: 'Do you consent to receiving correspondence about this application via email?',
        },
      }
    },
    CompanyContactInformation: {
      pageTitle: 'Your details (company representative)',
      pageSubtitle: '',
      fields: {
        givenName: {
          formikName: 'GivenNamesYourDetailsCompany',
          title: 'Given name(s)',
        },
        familyName: {
          formikName: 'FamilyNameYourDetailsCompany',
          title: 'Family name',
        },
        positionInCompany: {
          formikName: 'PositionInCompanyYourDetailsCompany',
          title: 'Position in company',
        },
        companyName: {
          formikName: 'CompanyNameYourDetailsCompany',
          title: 'Company name',
        },
        acnAbnType: {
          formikName: 'AbnAcnTypeYourDetailsCompany',
          title: 'ACN or ABN (an ACN is preferred)',
        },
        abnNumber: {
          formikName: 'ABNYourDetailsCompany',
          title: 'Enter the ACN/ABN number',
        },
        isABNValid: {
          formikName: 'isABNValidYourDetails',
          title: '',
        },
        acnNumber: {
          formikName: 'ACNYourDetailsCompany',
          title: 'Enter the ACN/ABN number',
        },
        isACNValid: {
          formikName: 'isACNValidYourDetails',
          title: '',
        },
        postalAddress: {
          formikName: 'PostalAddressYourDetailsCompany',
          title: 'Postal address',
        },
        isAddressSameAsPostal: {
          formikName: 'DifferentToPostalYourDetailsCompany',
          title: 'Is the street address different to the postal address?',
        },
        streetAddress: {
          formikName: 'StreetAddressYourDetailsCompany',
          title: 'Street address',
        },
        contactNumber: {
          formikName: 'ContactNumberYourDetailsCompany',
          title: '',
        },
        emailAddress: {
          formikName: 'EmailYourDetailsCompany',
          title: '',
        },
        noEmail: {
          formikName: 'YesNoEmailYourDetailsCompany',
          title: 'Select if you do not have an email address',
        },
      }
    },
    FineholderContactInformation: {
      pageTitle: 'Fineholder details',
      pageSubtitle: '',
      fields: {
        givenName: {
          formikName: 'GivenNamesFineholderDetails',
          title: 'Given name(s)',
        },
        familyName: {
          formikName: 'FamilyNameFineholderDetails',
          title: 'Family name',
        },
        dateOfBirth: {
          formikName: 'DOBFineholderDetails',
          title: 'Date of birth',
        },
        driverLicence: {
          formikName: 'DRIVER_LICENCE',
          title: 'Driver licence number',
        },
        licenceState: {
          formikName: 'StateOfIssueFineholderDetails',
          title: '',
        },
        countryOfIssue: {
          formikName: 'PlaceOfIssueFineholderDetails',
          title: '',
        },
        noDriverLicence: {
          formikName: 'YesNoDriverLicenceFineholderDetails',
          title: 'Select if you do not have a current driver licence',
        },
        postalAddress: {
          formikName: 'PostalAddressFineholderDetails',
          title: 'Postal address',
        },
        isAddressSameAsPostal: {
          formikName: 'DifferentToPostalFineholderDetails',
          title: "Is the fineholder's residential address different to their postal address?",
        },
        residentialAddress: {
          formikName: 'ResidentialAddressFineholderDetails',
          title: 'Residential address',
        },
        contactNumber: {
          formikName: 'ContactNumberFineholderDetails',
          title: '',
        },
        emailAddress: {
          formikName: 'EmailFineholderDetails',
          title: '',
        },
        noEmail: {
          formikName: 'YesNoEmailFineholderDetails',
          title: 'Select if you do not have an email address',
        },
      }
    },
    ThirdPartyRepContactInformation: {
      pageTitle: 'Your details (authorised representative)',
      pageSubtitle: '',
      fields: {
        givenName: {
          formikName: 'GivenNamesYourDetailsThirdParty',
          title: 'Given name(s)',
        },
        familyName: {
          formikName: 'FamilyNameYourDetailsThirdParty',
          title: 'Family name',
        },
        relationshipToFineholder: {
          formikName: 'RelationshipWithNamedPersonYourDetailsThirdParty',
          title: 'Your relationship to the person who received the fine (for example, family member, legal representative, support worker)',
        },
        organisationName: {
          formikName: 'OrganisationNameYourDetailsThirdParty',
          title: 'Organisation name (if applicable)',
        },
        postalAddress: {
          formikName: 'PostalAddressYourDetailsThirdParty',
          title: 'Postal address',
        },
        contactNumber: {
          formikName: 'ContactNumberYourDetailsThirdParty',
          title: '',
        },
        emailAddress: {
          formikName: 'EmailYourDetailsThirdParty',
          title: '',
        },
        noEmail: {
          formikName: 'YesNoEmailYourDetailsThirdParty',
          title: 'Select if you do not have an email address',
        },
        receiveApplication: {
          formikName: 'ReceiveApplicationViaEmailYourDetailsThirdParty',
          title: 'Would you like to receive a copy of the completed application at the email address provided?',
        },
        receiveCorrespondence: {
          formikName: 'CorrespondenceRecipientYourDetailsThirdParty',
          title: 'Where would you like us to send correspondence about this application?',
        },
      }
    },
  }
};
